module.exports = __webpack_public_path__ + "img/Logo_Color.01c85a07.png";